import { render, staticRenderFns } from "./AllMyTasksandAppointments.vue?vue&type=template&id=684cd3d1&"
import script from "./AllMyTasksandAppointments.vue?vue&type=script&lang=js&"
export * from "./AllMyTasksandAppointments.vue?vue&type=script&lang=js&"
import style0 from "./AllMyTasksandAppointments.vue?vue&type=style&index=0&id=684cd3d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports